import { DEBOUNCE_HISTORY_VERSION_TIME_PERIOD } from '@chegg-wt/core-wa/constants/paraphraser'
import history from '../history'

export const debounceHelper = (func: Function, delay: number) => {
  let timeout
  return (callNow: boolean = false, ...args) => {
    const after = () => {
      timeout = null
      func(...args)
    }
    if (timeout) clearTimeout(timeout)
    if (callNow) timeout = setTimeout(after, 0)
    // To trigger function after all asynchronous operations
    else timeout = setTimeout(after, delay)
  }
}

export const debounceOnCommitHistory = debounceHelper(
  () => history.commit(),
  DEBOUNCE_HISTORY_VERSION_TIME_PERIOD
)
